import React from 'react';
import { SectionHeading } from '../SectionHeading';
import { CtaButton } from '../CtaButton';
import { days } from '../../data/content';
export function Days() {
  return <section className="bg-white px-5 py-16 sm:py-24" data-id="element-136" data-mp="1fvtqbolydhx6">
      <div className="mx-auto max-w-3xl" data-id="element-137" data-mp="1fxekve89p0v1">
        <SectionHeading eyebrow="Volume VI" title={<>
              The complete <em className="text-brand-700" data-id="element-139" data-mp="1ow9pilvny2w8">7-day protocol</em>
            </>} subtitle="Here is the complete path that brings everything together." data-id="element-138" data-mp="1awqjbymex1mk" />
        <ol className="relative mt-10" data-id="element-140" data-mp="1kt3n5pbo8vv1">
          <span className="absolute bottom-6 left-7 top-6 w-0.5 bg-brand-100" aria-hidden="true" data-id="element-141" data-mp="1ymktg8fckc34" />
          {days.map(d => <li key={d.day} className="relative flex items-start gap-5 pb-6 last:pb-0" data-id="element-142" data-mp="1tnrstgl5sfkd">
              <span className="relative z-10 flex h-14 w-14 shrink-0 flex-col items-center justify-center rounded-2xl bg-brand-700 text-white" data-id="element-143" data-mp="28lado7upu8mj">
                <span className="text-[10px] font-bold uppercase leading-none text-brand-200" data-id="element-144" data-mp="23jl3eufbhyzi">Day</span>
                <span className="font-display text-2xl font-bold leading-none" data-id="element-145" data-mp="xltdgcye9hfr">{d.day}</span>
              </span>
              <div className="flex-1 rounded-2xl bg-cream px-5 py-4" data-id="element-146" data-mp="11noerhgbrutj">
                <h3 className="text-lg font-extrabold uppercase tracking-wide text-brand-800" data-id="element-147" data-mp="11prbslfwao7r">{d.name}</h3>
                <p className="mt-1 text-[16px] leading-snug text-ink-soft" data-id="element-148" data-mp="16k5249fpa55k">{d.text}</p>
              </div>
            </li>)}
        </ol>
        <CtaButton label="I want to start Day 1 today" className="mt-12" data-id="element-149" data-mp="1gjni6eshp6sc" />
      </div>
    </section>;
}